<template>
  <ListHeader/>

  <div class="bg-white flex items-end pt-8 pb-10 z-3 lg:sticky" :style="`top:${topPosition}px`">
    <div class="w-1/2 pr-5 lg:w-144 lg:pr-12">
      <ListWeekSelect/>
    </div>
    <div class="flex justify-end w-1/2 pl-5" v-if="!isLargeScreen">
      <ListWeekButtons/>
    </div>

    <div
        class="grid flex-grow grid-cols-7 gap-6 xl:gap-12"
        v-if="isLargeScreen"
    >
      <div
          class="text-14 text-blue-900 font-bold"
          v-for="day in currentWeekDays"
          :key="day.date"
      >
        {{
          day.shortName
        }}<span class="text-8 font-normal ml-2">{{ day.date }}</span>
      </div>
    </div>
  </div>

  <div
      class="divide-y divide-gray-200 border-t-1px border-b-1px border-gray-200"
  >
    <ListItem
        v-for="room in rooms"
        :key="room.id"
        :id="room.id"
        :roomHash="room.hash"
        :name="room.name"
        :description="room.description"
        :number="room.number"
        :image="room.image_path"
        :prices="room.prices"
        :timetable="room.timetable"
        :currency="room.currency"
        :pictureIcon="room.picture_icon_path"
        :pictureIconWidthPercentage="room.picture_icon_width_percentage"
        :pictureText="room.picture_text"
        :pictureTextColor="room.picture_text_color"
        :pictureTextBackgroundColor="room.picture_text_background_color"
        :pictureIconXPercentage="room.picture_icon_x_percentage"
        :pictureIconYPercentage="room.picture_icon_y_percentage"
        @change="nextStep"
    />
  </div>

  <Alert class="mt-16" ref="messageEl" v-if="message">{{ message }}</Alert>
</template>

<script>
import {useMediaQuery, useElementSize} from '@vueuse/core';
import {ref, computed} from 'vue';
import {rooms, selectedTimeCode} from '@/stores/Rooms';
import {createOrder} from '@/stores/Order';
import {setUserDetailsView} from '@/stores/View';
import {currentWeekDays} from '@/stores/Weekdays';

import ListItem from '@/components/Room/ListItem';
import ListHeader from '@/components/Room/ListHeader';
import ListWeekSelect from '@/components/Room/ListWeekSelect';
import Alert from '@/components/Alert';
import ListWeekButtons from '@/components/Room/ListWeekButtons';
import {loadAmountServices} from '@/stores/Services';

export default {
  components: {
    ListItem,
    ListHeader,
    ListWeekSelect,
    Alert,
    ListWeekButtons
  },
  setup() {
    const loading = ref(false);
    const message = ref('');
    const messageEl = ref('');

    const nextStep = async () => {
      loading.value = true;
      const {success, message: orderMessage} = await createOrder();
      if (!success && orderMessage) {
        message.value = orderMessage;
        setTimeout(() => {
          if (messageEl.value) {
            const header = document.querySelector('header');
            scroll({
              top: messageEl.value.$el.offsetTop - header.offsetHeight - 100,
              behavior: 'smooth'
            });
          }
        }, 100);
      }

      if (success) {
        const {success: serviceSuccess, message: serviceMessage} =
            await loadAmountServices();
        if (!serviceSuccess && serviceMessage) {
          message.value = serviceMessage;
        }
        if (serviceSuccess) {
          setUserDetailsView();
        }
      }
      loading.value = false;
    };

    const isLargeScreen = useMediaQuery('(min-width: 1024px)');

    const headerSize = useElementSize(document.querySelector('header'))
    return {
      rooms,
      selectedTimeCode,
      loading,
      message,
      messageEl,
      nextStep,
      isLargeScreen,
      currentWeekDays,
      topPosition: computed(() => {
        return headerSize.height.value
      })
    };
  }
};
</script>
